import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, MultiEntityTypeEnum, OrderFlowEnum, OrderGratuityTypeEnum, ReceiveMethodEnum, StoreItemValidityEnum, SupportedCurrencyEnum, } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsEnum, IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { FixtureDiningOptionInfoDto } from './FixtureDiningOptionInfoDto';
import { FixtureOrderAddressDto } from './FixtureOrderAddressDto';
import { FixtureOrderDateInfoDto } from './FixtureOrderDateInfoDto';
import { FixtureOrderDelayedInfoDto } from './FixtureOrderDelayedInfoDto';
import { FixtureOrderElementDto } from './FixtureOrderElementDto';
import { FixtureOrderETAReadyDto } from './FixtureOrderETAReadyDto';
import { FixtureOrderGiftCardElemDto } from './FixtureOrderGiftCardElemDto';
import { FixtureOrderPaymentInformationDto } from './FixtureOrderPaymentInformationDto';
import { FixtureOrderPromotionElementDto } from './FixtureOrderPromotionElementDto';
import { FixtureOrderRecipientDto } from './FixtureOrderRecipientDto';
import { FixtureOrderServiceChargeDto } from './FixtureOrderServiceChargeDto';
import { FixtureOrderTipsInfoDto } from './FixtureOrderTipsInfoDto';
import { FixtureOrderTotalAmountsDto } from './FixtureOrderTotalAmountsDto';
import { FixtureOrderVendorMathDto } from './FixtureOrderVendorMathDto';
import { FixtureOrderWeightDto } from './FixtureOrderWeightDto';
import { FixtureSchedulingInfoDto } from './FixtureSchedulingInfoDto';
import { FixtureTaxInfoDto } from './FixtureTaxInfoDto';
export class FixtureNonPersistentCartDto {
    constructor() {
        this.giftcards = [];
    }
}
__decorate([
    ApiProperty({ type: () => String, description: 'uuid v4', example: 'e33acc6f-2f34-332c-92d3-d4199fb33345' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Merchant ID', example: 'e22acc6f-2f34-552c-92d3-x4199fb33345' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Store ID', example: 'e44acc6f-2f34-552c-92d3-x4199fb44445' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'User Id' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "userId", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'Parent order uuid. Present only if multiEntityType is specified and this is a child order',
        example: 'e44acc6f-2f34-552c-92d3-x4199fb44445',
    }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "parentOrderUuid", void 0);
__decorate([
    ApiPropertyOptional({
        enum: MultiEntityTypeEnum,
        description: "Indicated for the central location's order and for all child orders",
        example: MultiEntityTypeEnum.FOOD_HALL,
    }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "multiEntityType", void 0);
__decorate([
    ApiProperty({ enum: SupportedCurrencyEnum, example: SupportedCurrencyEnum.USD }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "currency", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Order number' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "orderNumber", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], FixtureNonPersistentCartDto.prototype, "current", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "grossTotal", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "subtotal", void 0);
__decorate([
    ApiProperty({ type: () => FixtureTaxInfoDto }),
    Type(() => FixtureTaxInfoDto),
    IsInstance(FixtureTaxInfoDto, { always: true }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", FixtureTaxInfoDto)
], FixtureNonPersistentCartDto.prototype, "defaultTax", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "total_discount", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "total_tax", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "total_quantity", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "total_gratuity", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "totalPosDelta", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "total", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Refunded amount in cents', example: 100 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "refundedAmount", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderPaymentInformationDto }),
    Type(() => FixtureOrderPaymentInformationDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderPaymentInformationDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderPaymentInformationDto)
], FixtureNonPersistentCartDto.prototype, "paymentInformation", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderElementDto, isArray: true }),
    Type(() => FixtureOrderElementDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(FixtureOrderElementDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], FixtureNonPersistentCartDto.prototype, "elements", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderPromotionElementDto, isArray: true }),
    Type(() => FixtureOrderPromotionElementDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(FixtureOrderPromotionElementDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], FixtureNonPersistentCartDto.prototype, "promotions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderGiftCardElemDto, isArray: true, default: [] }),
    Type(() => FixtureOrderGiftCardElemDto),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsInstance(FixtureOrderGiftCardElemDto, { each: true, always: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], FixtureNonPersistentCartDto.prototype, "giftcards", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Gift cards total' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "giftCardsTotal", void 0);
__decorate([
    ApiProperty({ enum: OrderFlowEnum, example: OrderFlowEnum.REGULAR }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(OrderFlowEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "flow", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "notes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderAddressDto, description: 'Order address' }),
    Type(() => FixtureOrderAddressDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderAddressDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderAddressDto)
], FixtureNonPersistentCartDto.prototype, "address", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], FixtureNonPersistentCartDto.prototype, "deliveryFee", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "deliveryFeeAmount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "deliveryFeeTaxAmount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "deliveryFeeTaxPercentage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderDelayedInfoDto }),
    Type(() => FixtureOrderDelayedInfoDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderDelayedInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderDelayedInfoDto)
], FixtureNonPersistentCartDto.prototype, "delayedInfo", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderServiceChargeDto, isArray: true }),
    Type(() => FixtureOrderServiceChargeDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(FixtureOrderServiceChargeDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], FixtureNonPersistentCartDto.prototype, "serviceCharges", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreItemValidityEnum, example: StoreItemValidityEnum.VALID }),
    IsUndefinable({ always: true }),
    IsEnum(StoreItemValidityEnum),
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "validity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], FixtureNonPersistentCartDto.prototype, "isAbandoned", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Time zone' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "tz", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderTipsInfoDto }),
    Type(() => FixtureOrderTipsInfoDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderTipsInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderTipsInfoDto)
], FixtureNonPersistentCartDto.prototype, "tipsInfo", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderDateInfoDto }),
    Type(() => FixtureOrderDateInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderDateInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderDateInfoDto)
], FixtureNonPersistentCartDto.prototype, "dateInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderVendorMathDto }),
    Type(() => FixtureOrderVendorMathDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderVendorMathDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderVendorMathDto)
], FixtureNonPersistentCartDto.prototype, "math", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderRecipientDto }),
    Type(() => FixtureOrderRecipientDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderRecipientDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderRecipientDto)
], FixtureNonPersistentCartDto.prototype, "recipient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderWeightDto }),
    Type(() => FixtureOrderWeightDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderWeightDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderWeightDto)
], FixtureNonPersistentCartDto.prototype, "weight", void 0);
__decorate([
    ApiProperty({ type: () => FixtureSchedulingInfoDto }),
    Type(() => FixtureSchedulingInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureSchedulingInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureSchedulingInfoDto)
], FixtureNonPersistentCartDto.prototype, "schedulingInfo", void 0);
__decorate([
    ApiProperty({ type: () => FixtureDiningOptionInfoDto }),
    Type(() => FixtureDiningOptionInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureDiningOptionInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureDiningOptionInfoDto)
], FixtureNonPersistentCartDto.prototype, "diningOptionInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Date tz', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    IsDate({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Date)
], FixtureNonPersistentCartDto.prototype, "dateTz", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureOrderETAReadyDto }),
    Type(() => FixtureOrderETAReadyDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderETAReadyDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderETAReadyDto)
], FixtureNonPersistentCartDto.prototype, "ETAReady", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date tz', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    IsDate({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Date)
], FixtureNonPersistentCartDto.prototype, "fulfillmentDateTz", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderGratuityTypeEnum, example: OrderGratuityTypeEnum.FIX }),
    IsUndefinable({ always: true }),
    IsEnum(OrderGratuityTypeEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "gratuity_type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureNonPersistentCartDto.prototype, "gratuity_amount", void 0);
__decorate([
    ApiPropertyOptional({ enum: ReceiveMethodEnum, example: ReceiveMethodEnum.PICKUP }),
    IsUndefinable({ always: true }),
    IsEnum(ReceiveMethodEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "receive_method", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Phone number', example: '+12025550161' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "phoneNumber", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Recipient name number', example: 'Test User' }),
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    __metadata("design:type", String)
], FixtureNonPersistentCartDto.prototype, "recipient_name", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], FixtureNonPersistentCartDto.prototype, "date", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], FixtureNonPersistentCartDto.prototype, "fulfillmentDate", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderTotalAmountsDto, description: 'Various total sums of money in cents received' }),
    Type(() => FixtureOrderTotalAmountsDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureOrderTotalAmountsDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureOrderTotalAmountsDto)
], FixtureNonPersistentCartDto.prototype, "totalAmounts", void 0);
//# sourceMappingURL=FixtureNonPersistentCartDto.js.map